import type {
	SceneEngine,
	SceneEngineOptions,
} from "@animech/axiom-scene-utilities";
import { WEBGPU_PARAM } from "src/core/query-params";

/**
 * Whether the hash route query opted into WebGPU with exactly `webgpu=1`.
 * Captured at module load, before the router consumes and rewrites the hash
 * query; the scene engine falls back to WebGL2 when WebGPU is unavailable.
 */
export const webgpuRequested =
	typeof window !== "undefined" &&
	new URLSearchParams(window.location.hash.split("?")[1]).get(WEBGPU_PARAM) ===
		"1";

/**
 * Initializes the scene engine on WebGPU when `webgpu` is set and on WebGL2
 * otherwise. When WebGPU was requested it logs the backend that came up, which
 * is WebGL2 where WebGPU is unavailable.
 */
export async function initSceneEngine(
	sceneEngine: SceneEngine,
	webgpu: boolean,
	canvas: HTMLCanvasElement,
	configUrl: string,
	scenePath: string,
	options: SceneEngineOptions,
): Promise<void> {
	await sceneEngine.init(canvas, configUrl, scenePath, {
		...options,
		webgpuEnabled: webgpu,
	});
	if (webgpu) {
		// eslint-disable-next-line no-console
		console.info(
			`[Renderer] ${sceneEngine.Application.graphicsDevice.deviceType} (WebGPU requested)`,
		);
	}
}
